import React, { useState } from 'react';
import { XIcon, PlusIcon, MinusIcon } from 'lucide-react';
export function CreateSceneModal({
  onClose,
  onCreate
}) {
  const [sceneName, setSceneName] = useState('');
  const [description, setDescription] = useState('');
  const [triggerType, setTriggerType] = useState('time');
  const [triggerValue, setTriggerValue] = useState('');
  const [selectedDevices, setSelectedDevices] = useState([]);
  const [deviceActions, setDeviceActions] = useState({});
  const availableDevices = [{
    id: 'ac-1',
    name: 'IR AC Pod - Bedroom',
    type: 'ac'
  }, {
    id: 'plug-1',
    name: 'Smart Plug - Living Room',
    type: 'plug'
  }, {
    id: 'plug-2',
    name: 'Smart Plug - Kitchen',
    type: 'plug'
  }, {
    id: 'plug-3',
    name: 'Smart Plug - TV',
    type: 'plug'
  }, {
    id: 'plug-4',
    name: 'Smart Plug - Lights',
    type: 'plug'
  }];
  const handleDeviceToggle = deviceId => {
    if (selectedDevices.includes(deviceId)) {
      setSelectedDevices(selectedDevices.filter(id => id !== deviceId));
      const newActions = {
        ...deviceActions
      };
      delete newActions[deviceId];
      setDeviceActions(newActions);
    } else {
      setSelectedDevices([...selectedDevices, deviceId]);
    }
  };
  const handleActionChange = (deviceId, action) => {
    setDeviceActions({
      ...deviceActions,
      [deviceId]: action
    });
  };
  const handleCreate = () => {
    const device = availableDevices.find(d => d.id === selectedDevices[0]);
    const actions = selectedDevices.map(deviceId => {
      const device = availableDevices.find(d => d.id === deviceId);
      return {
        device: device.name,
        action: deviceActions[deviceId] || 'No action set'
      };
    });
    onCreate({
      name: sceneName,
      description,
      devices: selectedDevices.map(id => availableDevices.find(d => d.id === id).name),
      trigger: `${triggerType === 'time' ? 'Time:' : 'Location:'} ${triggerValue}`,
      active: false,
      lastActivated: new Date().toISOString(),
      actions
    });
  };
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" data-id="element-98">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" data-id="element-99">
        <div className="sticky top-0 bg-white border-b border-gray-200 p-6 flex justify-between items-center" data-id="element-100">
          <h2 className="text-xl font-semibold" data-id="element-101">Create New Scene</h2>
          <button onClick={onClose} className="p-1 hover:bg-gray-100 rounded-full" data-id="element-102">
            <XIcon size={20} data-id="element-103" />
          </button>
        </div>
        <div className="p-6 space-y-6" data-id="element-104">
          <div data-id="element-105">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-106">
              Scene Name
            </label>
            <input type="text" value={sceneName} onChange={e => setSceneName(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" placeholder="e.g., Good Morning" data-id="element-107" />
          </div>
          <div data-id="element-108">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-109">
              Description
            </label>
            <textarea value={description} onChange={e => setDescription(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" rows={2} placeholder="Describe what this scene does" data-id="element-110" />
          </div>
          <div data-id="element-111">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-112">
              Trigger Type
            </label>
            <div className="grid grid-cols-3 gap-3" data-id="element-113">
              <button onClick={() => setTriggerType('time')} className={`px-4 py-2 rounded-lg border ${triggerType === 'time' ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-300 text-gray-700'}`} data-id="element-114">
                Time
              </button>
              <button onClick={() => setTriggerType('location')} className={`px-4 py-2 rounded-lg border ${triggerType === 'location' ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-300 text-gray-700'}`} data-id="element-115">
                Location
              </button>
              <button onClick={() => setTriggerType('manual')} className={`px-4 py-2 rounded-lg border ${triggerType === 'manual' ? 'border-green-500 bg-green-50 text-green-700' : 'border-gray-300 text-gray-700'}`} data-id="element-116">
                Manual
              </button>
            </div>
          </div>
          {triggerType !== 'manual' && <div data-id="element-117">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-118">
                {triggerType === 'time' ? 'Time' : 'Location Condition'}
              </label>
              <input type={triggerType === 'time' ? 'time' : 'text'} value={triggerValue} onChange={e => setTriggerValue(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-green-500" placeholder={triggerType === 'time' ? 'Select time' : 'e.g., Away from home'} data-id="element-119" />
            </div>}
          <div data-id="element-120">
            <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-121">
              Select Devices
            </label>
            <div className="space-y-2 max-h-40 overflow-y-auto border border-gray-200 rounded-lg p-3" data-id="element-122">
              {availableDevices.map(device => <label key={device.id} className="flex items-center p-2 hover:bg-gray-50 rounded cursor-pointer" data-id="element-123">
                  <input type="checkbox" checked={selectedDevices.includes(device.id)} onChange={() => handleDeviceToggle(device.id)} className="mr-3" data-id="element-124" />
                  <span className="text-sm" data-id="element-125">{device.name}</span>
                </label>)}
            </div>
          </div>
          {selectedDevices.length > 0 && <div data-id="element-126">
              <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-127">
                Device Actions
              </label>
              <div className="space-y-3" data-id="element-128">
                {selectedDevices.map(deviceId => {
              const device = availableDevices.find(d => d.id === deviceId);
              return <div key={deviceId} className="border border-gray-200 rounded-lg p-3" data-id="element-129">
                      <p className="text-sm font-medium mb-2" data-id="element-130">{device.name}</p>
                      {device.type === 'ac' ? <div className="flex items-center gap-3" data-id="element-131">
                          <label className="text-sm text-gray-600" data-id="element-132">
                            Temperature:
                          </label>
                          <input type="range" min="16" max="30" value={deviceActions[deviceId]?.split(' ')[0] || '24'} onChange={e => handleActionChange(deviceId, `${e.target.value}°C`)} className="flex-1" data-id="element-133" />
                          <span className="text-sm font-medium w-12" data-id="element-134">
                            {deviceActions[deviceId] || '24°C'}
                          </span>
                        </div> : <div className="flex gap-2" data-id="element-135">
                          <button onClick={() => handleActionChange(deviceId, 'Turn on')} className={`flex-1 px-3 py-1 rounded text-sm ${deviceActions[deviceId] === 'Turn on' ? 'bg-green-100 text-green-700 border border-green-300' : 'bg-gray-100 text-gray-700'}`} data-id="element-136">
                            Turn On
                          </button>
                          <button onClick={() => handleActionChange(deviceId, 'Turn off')} className={`flex-1 px-3 py-1 rounded text-sm ${deviceActions[deviceId] === 'Turn off' ? 'bg-red-100 text-red-700 border border-red-300' : 'bg-gray-100 text-gray-700'}`} data-id="element-137">
                            Turn Off
                          </button>
                        </div>}
                    </div>;
            })}
              </div>
            </div>}
        </div>
        <div className="sticky bottom-0 bg-white border-t border-gray-200 p-6 flex justify-end gap-3" data-id="element-138">
          <button onClick={onClose} className="px-4 py-2 text-gray-700 hover:bg-gray-100 rounded-lg" data-id="element-139">
            Cancel
          </button>
          <button onClick={handleCreate} disabled={!sceneName || selectedDevices.length === 0 || !triggerValue} className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 disabled:cursor-not-allowed" data-id="element-140">
            Create Scene
          </button>
        </div>
      </div>
    </div>;
}